import { useEffect } from "react";
import { useCity } from "@/contexts/CityContext";
import { RoundsList } from "@/components/rounds/RoundsList";
import { track } from "@/lib/analytics";
import { useRoundsCommunities } from "@/lib/rounds";

export default function Rounds() {
  const { city } = useCity();
  const communities = useRoundsCommunities(city.slug);

  useEffect(() => track("rounds_view"), []);

  if (communities.isLoading) return <div className="pb-rounds-state" role="status">Loading Rounds…</div>;
  if (communities.isError || !communities.data) {
    return (
      <div className="pb-rounds-state pb-rounds-state--error" role="alert">
        <span>Rounds communities could not be loaded.</span>
        <button type="button" onClick={() => void communities.refetch()}>Retry</button>
      </div>
    );
  }

  return (
    <RoundsList
      citySlug={city.slug}
      communities={communities.data.communities}
      title="Rounds"
      description="Practical, local discussion with registered clinicians. Keep every case free of patient identifiers."
    />
  );
}
